var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreakTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 24.6111H10.6435M10.6435 24.6111H10.801M10.6435 24.6111C10.6697 24.6114 10.696 24.6114 10.7222 24.6114C10.7485 24.6114 10.7747 24.6114 10.801 24.6111M10.6435 24.6111C5.31028 24.5687 1 20.2317 1 14.8886V9.22618C1 8.51812 1.57368 7.94444 2.28174 7.94444H19.1621C19.8701 7.94444 20.4444 8.51812 20.4444 9.22618V9.33333M10.801 24.6111H20.4444M10.801 24.6111C16.1342 24.5687 20.4444 20.2317 20.4444 14.8886M20.4444 9.33333H22.5278C24.4454 9.33333 26 10.8879 26 12.8056C26 14.7232 24.4454 16.2778 22.5278 16.2778H20.4444V14.8886M20.4444 9.33333V14.8886M16.2778 1L14.8889 3.77778M12.1111 1L10.7222 3.77778M7.94444 1L6.55556 3.77778",
    stroke: "#FF931E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakTime);
export default __webpack_public_path__ + "static/media/breakTime.50fc364fde5b67fd67134c23d810e130.svg";
export { ForwardRef as ReactComponent };